import { render, staticRenderFns } from "./FastOrdersTable.vue?vue&type=template&id=4b432f72&scoped=true"
import script from "./FastOrdersTable.vue?vue&type=script&lang=js"
export * from "./FastOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./FastOrdersTable.vue?vue&type=style&index=0&id=4b432f72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b432f72",
  null
  
)

export default component.exports